<apx-chart [series]="series" [chart]="chart" [xaxis]="xaxis" [yaxis]="yaxis" [fill]="fill"
    [stroke]="stroke" [tooltip]="tooltip"></apx-chart>